import React, { useState, useEffect, useCallback } from "react";
import { Typography, Button, TextField, Grid, FormGroup } from "@mui/material";
import useStyles from "./style";
import { useFormik } from "formik";
import * as yup from "yup";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import _ from "lodash";

//Api routes
import settingsApi from "Services/Settings";

const Settings = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  // States
  const [values, setValues] = useState([]);


  const handleSettings = (formValues) => {
    dispatch(showLoader("Loading please wait..."));

    const data = {
      user_reward_fee: formValues?.user_reward_fee
    };
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "Updated reward settings successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        formik?.resetForm();
        setValues(null);
        getMasterValues();
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while update settings",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("settings value update api", err);
    };
    settingsApi.updateuserRewardformSettings({ ...data }).then(onSuccess, onFailure);
  };

  const formik = useFormik({
    initialValues: {
      user_reward_fee: "0",
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      user_reward_fee: yup
        .number()
        .typeError("Must be a number")
        .min(0, "Must be greater than or equal to 0")
        .nullable(),
    }),
    onSubmit: handleSettings,
  });

  // Get Payment Settings
  const getMasterValues = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      //console.log("payment settings details ", res.data);

      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setValues(res?.data?.data);
      } else {
        setValues([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    settingsApi.getuserRewardformSettings().then(onSuccess, onFailure);
  }, []);

  useEffect(() => {
    getMasterValues();
  }, [getMasterValues]);

  // Formik - Set fetched values for master
  useEffect(() => {
    if (!_.isEmpty(values)) {
      formik.setFieldValue("user_reward_fee", values?.user_reward_fee);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  return (
    <>
      <Grid container className={classes.cardContainer}>
        <Grid
          item
          xs={12}
          md={12}
          lg={12}
          xl={12}
          className={classes.container}
        >
          <div style={{ padding: "15px" }}>
            <Typography variant="h5">User Reward Settings</Typography>
          </div>
        </Grid>

        <Grid item xs={12} md={6} lg={6} xl={6} className={classes.container}>
          {/* Platform fee */}
          <Grid
            item
            xs={12}
            md={6}
            lg={12}
            xl={12}
            className={classes.fieldWrapper}
          >
            <TextField
              name="user_reward_fee"
              id="user_reward_fee"
              value={formik?.values?.user_reward_fee}
              defaultValue={formik?.values?.user_reward_fee}
              onChange={formik?.handleChange}
              type={"text"}
              fullWidth
              variant="outlined"
              size="small"
              label="User Reward / KM"   
              error={
                formik?.errors?.user_reward_fee && formik?.touched?.user_reward_fee
              }
              helperText={
                formik?.errors?.user_reward_fee &&
                formik?.touched?.user_reward_fee &&
                formik?.errors?.user_reward_fee
              }
            />
          </Grid>
 
        </Grid>

        <Grid
          item
          xs={12}
          md={6}
          lg={6}
          xl={6}
          className={classes.container}
        ></Grid>
        <Grid item xs={12} md={6} lg={12} xl={12} className={classes.btn}>
          <Button variant="contained" onClick={formik.handleSubmit}>
            Update
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default Settings;
